// src/services/subHeadquarter.service.js
import api from './api';

const subHeadquarterService = {
  // Create sub-headquarter
  createSubHeadquarter: async (subHqData) => {
    try {
      const response = await api.post('/subheadquarters', subHqData);
      return response.data;
    } catch (error) {
      console.error('Error creating sub-headquarter:', error);
      throw error;
    }
  },

  // Get all sub-headquarters (paginated)
  getSubHeadquarters: async (companyId, page = 1, limit = 10, search = '') => {
    try {
      const params = { page, limit };
      if (search) params.search = search;
      if (companyId) params.companyId = companyId;

      const response = await api.get('/subheadquarters', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching sub-headquarters:', error);
      throw error;
    }
  },

  // Get sub-headquarters by headquarter (for dropdowns)
  getSubHeadquartersByHeadquarter: async (headquarterId) => {
    try {
      const response = await api.get(`/subheadquarters/headquarter/${headquarterId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching sub-headquarters by HQ:', error);
      throw error;
    }
  },

  // Get sub-headquarter by ID
  getSubheadquarterById: async (id) => {
    try {
      const response = await api.get(`/subheadquarters/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching sub-headquarter:', error);
      throw error;
    }
  },

  // Update sub-headquarter
  updateSubHeadquarter: async (id, subHqData) => {
    try {
      const response = await api.post(`/subheadquarters/${id}`, subHqData);
      return response.data;
    } catch (error) {
      console.error('Error updating sub-headquarter:', error);
      throw error;
    }
  },

  // Delete sub-headquarter
  deleteSubHeadquarter: async (id) => {
    try {
      const response = await api.delete(`/subheadquarters/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting sub-headquarter:', error);
      throw error;
    }
  },

  // Change sub-HQ to different HQ
  changeSubHeadquarterHQ: async (changeData) => {
    try {
      const response = await api.post('/subheadquarters/change-hq', changeData);
      return response.data;
    } catch (error) {
      console.error('Error changing sub-headquarter HQ:', error);
      throw error;
    }
  },
};

export default subHeadquarterService;